\<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="공정 또는 작업장명"
            name="processName"
            v-model="searchParam.processName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="실내외구분"
            name="inOutFlag"
            v-model="searchParam.inOutFlag">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="발생원"
            name="sourceName"
            v-model="searchParam.sourceName">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-line
            label="관련라인"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-line>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="관리부서"
            :isFirstValue="false"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="localven"
          title="환기장치(국소배기장치) 목록"
          tableId="localven"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="등록" icon="add" @btnClicked="equipmentPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'local-ven',
  data() {
    return {
      grid: {
        columns: [
          {
            fix: true,
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            fix: true,
            name: 'lineCd',
            field: 'lineCd',
            label: 'LINE',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            fix: true,
            name: 'location',
            field: 'location',
            label: '장소',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            fix: true,
            name: 'processName',
            field: 'processName',
            label: '공정또는작업장명',
            style: 'width:150px',
            align: 'left',
            type: 'link',
            sortable: true,
          },
          {
            name: 'inOutFlag',
            field: 'inOutFlag',
            label: '실내외구분',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'sourceName',
            field: 'sourceName',
            label: '발생원',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'harmfulTypeCd',
            field: 'harmfulTypeCd',
            label: '유해물질종류',
            style: 'width:120px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'hoodForm',
            field: 'hoodForm',
            label: '후드형식',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'hoodVelocity',
            field: 'hoodVelocity',
            label: '후드의제어풍속(m/s)',
            style: 'width:120px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'reactionVelocity',
            field: 'reactionVelocity',
            label: '덕트내반응속도(m/s)',
            style: 'width:120px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'airVolume',
            field: 'airVolume',
            label: '배풍량(㎥/min)',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'motorVolume',
            field: 'motorVolume',
            label: '송풍기-용량(Kw)',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'motorExplosionForm',
            field: 'motorExplosionForm',
            label: '송풍기-방폭형식',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'airCleanType',
            field: 'airCleanType',
            label: '공기정화장치형식',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'airExhaustOrder',
            field: 'airExhaustOrder',
            label: '배기 및 처리순서',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        processName: '',
        inOutFlag: '',
        sourceName: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.lbe.localven.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./localExhaustSystemPlanInfoDetail.vue"}`);
      this.popupOptions.title = '환기장치(국소배기장치) 상세';
      this.popupOptions.param = {
        psiLocalVentilationId: result ? result.psiLocalVentilationId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
